import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-425be117"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog p-3 rounded-top-3" }
const _hoisted_2 = { class: "title text-black" }
const _hoisted_3 = { class: "withdraw-word fs-15-custom" }
const _hoisted_4 = { class: "text-black d-flex justify-content-center align-items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "youan me-2" }, "￥", -1))
const _hoisted_6 = { class: "amount fw-semibold" }
const _hoisted_7 = { class: "content-1 rounded-3 p-3 text-start fs-15-custom text-black" }
const _hoisted_8 = {
  key: 0,
  class: "item d-flex align-items-center mb-3"
}
const _hoisted_9 = { class: "label" }
const _hoisted_10 = { class: "text-multi-line" }
const _hoisted_11 = {
  key: 1,
  class: "item d-flex align-items-center"
}
const _hoisted_12 = { class: "label" }
const _hoisted_13 = { class: "text-multi-line" }
const _hoisted_14 = {
  key: 2,
  class: "d-flex item align-items-center"
}
const _hoisted_15 = { class: "label" }
const _hoisted_16 = { class: "text-multi-line" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString($setup.local.withdraw_28), 1),
    _createElementVNode("button", {
      class: "hide-btn position-absolute border-0 bg-transparent fs-15-custom",
      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.hide_()))
    }, _toDisplayString($setup.local.withdraw_24), 1),
    _createElementVNode("div", _hoisted_3, _toDisplayString($setup.local.withdraw_29), 1),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, _toDisplayString(Number($setup.props.amount)), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      ($setup.props.isAlipay)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString($setup.local.withdraw_14), 1),
            _createElementVNode("div", _hoisted_10, _toDisplayString($setup.props.account), 1)
          ]))
        : _createCommentVNode("", true),
      ($setup.props.isAlipay)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString($setup.local.withdraw_16), 1),
            _createElementVNode("div", _hoisted_13, _toDisplayString($setup.props.fullname), 1)
          ]))
        : _createCommentVNode("", true),
      (!$setup.props.isAlipay)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString($setup.local.withdraw_21), 1),
            _createElementVNode("div", _hoisted_16, _toDisplayString($setup.props.address), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('submit'))),
      class: "submit-btn active-submit-btn border-0 rounded-5 p-2 my-4"
    }, _toDisplayString($setup.local.withdraw_31), 1)
  ]))
}